import React from 'react'

const SkillToSales = () => {
  return (
    <div>SkillToSales</div>
  )
}

export default SkillToSales